// mantine
import { Avatar } from '@mantine/core';
// icons
import { ChevronDown } from 'lucide-react';
// components
import { PopoverButton } from '@newo/ui-kit';
// utils
import { TPersona } from '@newo/api/gateway';
import SelectPersonaForm from '@/pages/AKB/components/PersonaSelect/components/SelectPersonaForm';
import useAKBStore from '@/pages/AKB/AKB.store.ts';
// assets
import styles from '@/pages/AKB/components/PersonaSelect/PersonaSelect.module.css';

const PersonaSelect = () => {
    const selectedPersona = useAKBStore((state) => state.persona);
    const setPersona = useAKBStore((state) => state.setPersona);

    const handleSubmit = (persona: TPersona) => {
        setPersona(persona);
    };
    return (
        <PopoverButton
            className={styles.button}
            trigger={
                <>
                    <Avatar color="blue" radius="xl" size="md">
                        {selectedPersona?.name.at(0)}
                    </Avatar>
                    <div>
                        {selectedPersona ? (
                            <div className="mb-1 whitespace-nowrap text-sm">
                                {selectedPersona.name} <ChevronDown />
                            </div>
                        ) : (
                            <div className="whitespace-nowrap text-sm">
                                Choose person <ChevronDown />
                            </div>
                        )}
                    </div>
                </>
            }
        >
            {(close) => (
                <SelectPersonaForm onClose={close} onSubmit={handleSubmit} />
            )}
        </PopoverButton>
    );
};

export default PersonaSelect;
